export default __webpack_public_path__ + "static/media/1d.3a251df9.png";